import { useAuth } from '@/contexts/AuthContext'

export default function InstructorDashboard() {
  const { profile } = useAuth()

  return (
    <div>
      <div style={{ font: '600 26px Lora, serif', color: '#1B2A4A', marginBottom: 6 }}>
        Dashboard
      </div>
      <div style={{ font: '400 14px Inter, sans-serif', color: 'rgba(27,42,74,0.55)', marginBottom: 28 }}>
        Welcome back, {profile?.full_name ?? 'Instructor'}
      </div>

      <div className='g4stat' style={{ marginBottom: 28 }}>
        {[
          { label: 'Active students', value: '—' },
          { label: 'Mock tests this week', value: '—' },
          { label: 'Certificates issued', value: '—' },
          { label: 'Avg. readiness score', value: '—' },
        ].map(stat => (
          <div key={stat.label} style={{
            background: '#fff', border: '1px solid rgba(27,42,74,0.08)',
            borderRadius: 12, padding: '18px 20px',
          }}>
            <div style={{ font: '700 28px Lora, serif', color: '#1B2A4A' }}>{stat.value}</div>
            <div style={{ font: '400 12.5px Inter, sans-serif', color: 'rgba(27,42,74,0.55)', marginTop: 4 }}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className='banner-info'>
        Instructor portal is ready. Student enrollment, mock tests, and skill checklists will be wired up in Phase 2.
      </div>
    </div>
  )
}
